import { render, staticRenderFns } from "./Job title.vue?vue&type=template&id=c72acf66"
import script from "./Job title.vue?vue&type=script&lang=js"
export * from "./Job title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports